
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ParticuliersPage = lazy(() => import('../pages/particuliers/page'));
const ProfessionnelsPage = lazy(() => import('../pages/professionnels/page'));
const ArtisansPage = lazy(() => import('../pages/professionnels/artisans/page'));
const TpePmePage = lazy(() => import('../pages/professionnels/tpe-pme/page'));
const LiberauxPage = lazy(() => import('../pages/professionnels/liberaux/page'));
const MicroEntrepreneurPage = lazy(() => import('../pages/professionnels/micro-entrepreneur/page'));
const CadresPage = lazy(() => import('../pages/professionnels/cadres/page'));
const DirigeantsPage = lazy(() => import('../pages/professionnels/dirigeants/page'));
const FormulairePage = lazy(() => import('../pages/formulaire/page'));
const AProposPage = lazy(() => import('../pages/a-propos/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/particuliers',
    element: <ParticuliersPage />,
  },
  {
    path: '/professionnels',
    element: <ProfessionnelsPage />,
  },
  {
    path: '/professionnels/artisans',
    element: <ArtisansPage />,
  },
  {
    path: '/professionnels/tpe-pme',
    element: <TpePmePage />,
  },
  {
    path: '/professionnels/liberaux',
    element: <LiberauxPage />,
  },
  {
    path: '/professionnels/micro-entrepreneur',
    element: <MicroEntrepreneurPage />,
  },
  {
    path: '/professionnels/cadres',
    element: <CadresPage />,
  },
  {
    path: '/professionnels/dirigeants',
    element: <DirigeantsPage />,
  },
  {
    path: '/formulaire',
    element: <FormulairePage />,
  },
  {
    path: '/a-propos',
    element: <AProposPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
